import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from 'src/app/models/data/company';
import { Role } from 'src/app/models/data/role';
import { Mode } from 'src/app/models/model';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { AppNavigationHeaderComponent } from '../../components/navigation-header/app-navigation-header.component';
import { CompanyRolesTableComponent } from '../../components/company-roles-table/company-roles-table.component';
import { BreadcrumbLabelDirective } from '../../directives/breadcrumb-label.directive';

@Component({
	selector: 'app-role-main-tab',
	templateUrl: './role-main-tab.component.html',
	styleUrls: ['./role-main-tab.component.scss'],
	imports: [
		AppNavigationHeaderComponent,
		CompanyRolesTableComponent,
		BreadcrumbLabelDirective,
	],
})
export class RoleMainTabComponent {
	@Input() companyId!: string;
	@Input() company!: Company;

	rolesTableBreadcrumbLabel = $localize`:@@roles-rolesTableBreadcrumbLabel:Roles`;

	readonly getMyRoles = (queryParams: QueryParam[]) =>
		this.apiService.getMyRoles(queryParams);

	constructor(
		private apiService: ApiService,
		private readonly router: Router
	) {}

	onRoleSelected(event: { role: Role; mode: Mode }): void {
		this.router.navigate(['/roleDetail', event.role.id], {
			state: { role: event.role, mode: event.mode },
		});
	}
}
